export const emptyGuid = '00000000-0000-0000-0000-000000000000';
export const guid1 = '11111111-1111-1111-1111-111111111111';
/** Sentinel Guid for "Not assigned to me" filter; backend must check for this value and return tasks not assigned to current user */
export const notAssignedToMe = '22222222-2222-2222-2222-222222222222';
export const isGuid = value => {
  if (value == null || typeof value !== 'string' || value.length < 36) return false;
  return /^\{?[a-fA-F0-9]{8}-([a-fA-F0-9]{4}-){3}[a-fA-F0-9]{12}\}?$/.test(value);
};

export default { empty: emptyGuid, isGuid, notAssignedToMe, guid1 };

/*
Examples

import guid from '.../guid';
const emptyGuid=guid.empty;
if(guid.isGuid(emptyGuid))
  do something


Named import:

import {emtpyGuid,isGuid} from '.../guid';
const emptyGuid=emtpyGuid;
if(isGuid(emptyGuid))
  do something
*/
